import { HttpParams } from '@angular/common/http';

export interface IQueryParams {
  pageNumber?: number;
  pageSize?: number;
}

export function createQueryParams(query?: Partial<unknown>): HttpParams {
  let params = new HttpParams();

  if (query) {
    Object.keys(query).forEach((key) => {
      const keyTyped = key as keyof typeof query;
      const value = query[keyTyped];
      if (value !== null && value !== undefined) {
        //check if value is an array and append each value to the params
        if (Array.isArray(value)) {
          Array.from(value).forEach((value) => {
            params = params.append(key, encodeURIComponent(value as string));
          });
          return;
        }

        params = params.append(key, value);
      }
    });
  }
  return params;
}
